import request from '@/router/axios';

export const getList = (current, size, params) => {
  return request({
    url: '/api/blade-system/param/list',
    method: 'get',
    params: {
      ...params,
      current,
      size,
    }
  })
}

export const remove = (ids) => {
  return request({
    url: '/api/blade-system/param/remove',
    method: 'post',
    params: {
      ids,
    }
  })
}

export const add = (row) => {
  return request({
    url: '/api/blade-system/param/submit',
    method: 'post',
    data: row
  })
}

export const update = (row) => {
  return request({
    url: '/api/blade-system/param/submit',
    method: 'post',
    data: row
  })
}

// 获取特定参数详情
export const getParamsDetail = (paramKey) => {
  return request({
    url: '/api/blade-system/param/detail',
    method: 'get',
    params: {
      paramKey
    }
  })
}


// // 获取特定参数详情
// export const getBaoyinQuery = () => {
//   return request({
//     url: '/api/blade-system/param/detail',
//     method: 'get',
//     params: {
//       paramKey: 'baoyin_loan_post_id'
//     }
//   })
// }